// Cloaked Prototype Mode
// Quando REACT_APP_CLOAKED_MODE=true, la navigazione viene limitata
// alle sole pagine in whitelist (Home + Chi Siamo e relative sottopagine).
// Tutto il resto viene reindirizzato alla homepage.
//
// Per attivare/disattivare la modalità basta modificare la variabile
// in /app/frontend/.env e ricostruire/riavviare il frontend.

export const CLOAKED_MODE =
  String(process.env.REACT_APP_CLOAKED_MODE || "").toLowerCase() === "true";

// Pagine accessibili in modalità prototipo
export const ALLOWED_PATHS = [
  "/",
  "/chi-siamo",
  "/chi-siamo/storia-e-valori",
  "/chi-siamo/organismi",
  "/chi-siamo/statuto-e-regolamenti",
  "/chi-siamo/enti-collegati",
  "/chi-siamo/enti-collegati/promo-ter",
  "/chi-siamo/cat",
  "/chi-siamo/partner",
  "/chi-siamo/il-nostro-impegno",
  "/chi-siamo/trasparenza",
];

// Prefissi di path consentiti (per gestire eventuali sottopath dinamici di Chi Siamo)
const ALLOWED_PREFIXES = ["/chi-siamo"];

export function isPathAllowed(pathname) {
  if (!pathname) return false;
  // normalizza eventuale slash finale (eccetto la root)
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  if (ALLOWED_PATHS.includes(normalized)) return true;
  return ALLOWED_PREFIXES.some((p) => normalized.startsWith(p + "/"));
}
